import { FlexGrid, FlexGridProps, useStyletron } from "@mezo-org/mezo-clay"

type DashboardHeaderWrapperProps = FlexGridProps & {
  items: number
}

export default function DashboardHeaderWrapper({
  children,
  items,
  ...props
}: DashboardHeaderWrapperProps) {
  const [css, theme] = useStyletron()

  return (
    <FlexGrid
      flexGridColumnCount={items}
      flexGridColumnGap={theme.sizing.scale500}
      alignItems="center"
      justifyContent="space-between"
      className={css({
        zIndex: 100,
        background: theme.colors.white,
        position: "sticky",
        borderBottom: `1px solid ${theme.colors.borderOpaque}`,
        top: 0,
        left: 0,
        width: "100%",
      })}
      {...props}
    >
      {children}
    </FlexGrid>
  )
}
